export default "__VITE_ASSET__hvyiUDKn__"